import React from 'react';
// Images
import SmallMainImage from '../../assets/images/main/mistress-diva-pro-dominatrix-and-femdom-in-latex-session-black-and-white-miltary-hat.webp';
// Constants
import { CompanyName } from '../../utils/Constants';

function AboutInfoContainer2() {
  return (
    <section className='grid w-full'>
      <div className='grid md:grid-cols-rev text-center'>
        {/* About */}
        {/* <section className='grid w-full bg-colour4 full_shadow_black_invert'>
          <article className='grid gap-y-4 px-6 sm:px-8 md:px-12 lg:max-w-[80%] lg:mx-auto my-auto py-4 lg:text-xl'>
            <div>
              <h3 className='font-hello-paris-medium text-2xl lg:text-5xl'>
                About Queen<span className='pl-8'>Diva</span>
              </h3>
            </div>
            <div className='grid gap-4'>
              <p>
                Hailing from New Zealand My Domination experience spans over 20
                years. I am a naturally gifted Mistress who loves to enable
                submissive males like yourself to realise their full potential
                while serving Me.
              </p>
              <p>
                As a skilled BDSM practitioner, I am here as your guide, your
                confidante and most of all….your Mistress. Whether you’re a
                submissive, slave, seasoned devotee of submission or a curious
                explorer of kink, allow Me to guide you safely and sensually
                into the deepest darkest recesses of your mind and into the
                depths of your most deviant desires.
              </p>
              <p>
                My sessions are personalised and are one of a kind experiences.
                Utilizing My sexuality and My feminity to assert full control
                and Dominance over you to achieve My desires. Training slaves
                and submissives is My passion. Witnessing slaves suffer at My
                feet brings Me immense satisfaction
              </p>
            </div>
          </article>
        </section> */}

        <section className='grid items-center my-auto'>
          <section className=''>
            <img
              src={SmallMainImage}
              alt={`${CompanyName}`}
              className='mx-auto'
            />
          </section>
        </section>
      </div>
    </section>
  );
}

export default AboutInfoContainer2;
